import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  styled,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment,
  IconButton,
  Grid,
  Box,
  Typography,
  Paper,
  useMediaQuery,
  AppBar,
  Toolbar,
} from "@mui/material";
import img1 from "../../assets/images/Samarth - Logo new.svg";
import imgD from "../../assets/images/Group 27450.png";
import imgB from "../../assets/images/Annotation.png";
import imgC from "../../assets/images/Group 27452.png";
import "./Logincss.css";
import imageA from "../../assets/images/Group 1000003989.svg";
import imageB from "../../assets/images/Social Media Logo Thread 1.svg";
import imageC from "../../assets/images/Nodal Agency.svg";
import imageD from "../../assets/images/newimg.png";
import imageE from "../../assets/images/double-quotes 1.png";
import imageF from "../../assets/images/double-quotes 2.png";
// import imageG from "../../assets/images/Group 27363.png";
import imageG from "../../assets/images/SakshamLogo.svg";

// Custom Components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import DefaultNavbar from "../../examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Utilities
import { AGENT } from "utils/constant";
import { ADMIN } from "utils/constant";
import { height, spacing } from "@mui/system";
import Swal from "sweetalert2";

// Images
// import image from "../../assets/images/landing_img.png";
import image from "assets/sba_images/png/home_screen.png";
import logo from "../../assets/sba_images/png/SamarthaLogo.png";
import pageRoutes from "page.routes";
import Card from "@mui/material/Card";
import axios from "axios";
import { outlinedInputClasses } from "@mui/material";
import link from "assets/theme/components/link";
import Button from "@girishsawant999/react-loading-button";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import imgMain from "../../assets/images/image 154.png";
import imgA from "../../assets/images/Group 27479 (1).png";
import { Button as MuiButton } from "@mui/material";

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "rgba(255, 92, 0, 0.7)",
            borderRadius: "8px",
          },
          root: {
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "rgba(255, 92, 0, 0.7)",
            },
            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "rgba(255, 92, 0, 0.7)",
            },
          },
        },
      },
    },
  });

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  background: "white",
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  fontSize: "12px",
}));

const Login = () => {
  const matchlg = useMediaQuery("(max-width:768px)");
  const theme = useTheme();
  const matchsm = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const outerTheme = useTheme();
  const transparent = false;
  const light = false;
  const [userRole, setUserRole] = useState(AGENT);
  const [OTP, setOTP] = useState({
    mobileno: "",
    otp: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [counter, setCounter] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const [loginEmail, setLoginEmail] = useState({
    email: "",
    password: "",
  });

  const [otpbutton, Setotpbuton] = useState(false);
  const [otpinput, Setotpinput] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const sendOtp = () => {
    // Setotpinput(true);
    Setotpbuton(true);

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL_AUTH}/login/sendotp`, {
        mobnum: OTP.mobileno,
        partner_association: "Samarth",
      })
      .then((res) => {
        Setotpinput(true);
        Setotpbuton(true);
        Swal.fire({
          position: "top",
          icon: "sucess",
          title: `${res.response.data["User Message"]}`,
          // text: res.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      })
      .catch((err) => {
        Setotpbuton(false);
        // Setotpinput(false);
        Swal.fire({
          position: "top",
          icon: "warning",
          // title: `${err.response.data["User Message"]}`,
          title: "Oops...",
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  const changeUser = (e, type) => {
    // double clicking on same option deselects and sets type as null
    if (type !== null) {
      setUserRole(type);
    }
  };

  const CapitalizeFunc = (name) => {
    const arr = name.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(" ");
    console.log("Login access:", str2);
    return str2;
  };

  const handleLogin = async () => {
    setIsLoading(true);
    if (userRole === "admin") {
      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/login/phone`, {
          mobile_number: OTP.mobileno,
          otp: OTP.otp,
          // partner_association: "Samarth",
        })
        .then((res) => {
          console.log(res.data, "res1");
          if (res.status === 200) {
            sessionStorage.setItem("register_id", res.data["Registration ID"]);
            sessionStorage.setItem("token", res.data.Token.refresh);
            sessionStorage.setItem("user_name", res.data.Name);
            sessionStorage.setItem("cp_type", res.data.type);
            // navigate("/superadmin/dashboard");
            res.data.type === "Skilling Partner"
              ? navigate("/courses-assigned")
              : navigate("/dashboard");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          Swal.fire({
            position: "top",
            icon: "warning",
            title: `${err.response.data["Developer Message"]}`,
            showConfirmButton: false,
            timer: 3000,
          });
          setIsLoading(false);
        });
    } else {
      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/account/email/login`, {
          email: loginEmail.email,
          password: loginEmail.password,
          // partner_association: "Samarth",
        })
        .then((res) => {
          console.log(res.data, "res2");
          if (res.status === 200) {
            sessionStorage.setItem("email", loginEmail.email);
            sessionStorage.setItem("register_id", res.data["Registration ID"]);
            sessionStorage.setItem("creator_role", res.data["Creator_Role"]);
            sessionStorage.setItem("token", res.data["Token"].access);
            sessionStorage.setItem("user_name", res.data.Name);
            sessionStorage.setItem("cp_type", res.data.type);
            // navigate("/superadmin/dashboard");
            res.data.type === "Skilling Partner"
              ? navigate("/courses-assigned")
              : navigate("/dashboard");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          Swal.fire({
            position: "top",
            icon: "warning",
            title: "Oops...",
            // text: `${err.response?.message ? err.response.message : err.response.data["message"]}`,
            showConfirmButton: false,
            timer: 3000,
          });
          setIsLoading(false);
        });
    }
  };

  /*
  const handleKeyPress = async (e) => {
    setIsLoading(true);
    if (e.key === "Enter") {
      console.log("you have clicked enter button");
    }
  };
  */

  useEffect(() => {
    if (otpbutton) {
      setTimeout(() => {
        Setotpbuton(false);
        Setotpinput(false);
      }, 59000);
    }
  }, [otpbutton]);

  useEffect(() => {
    if (otpinput) {
      const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, otpinput]);

  const styles = {
    paperContainer: {
      backgroundImage: `url(${"../../assets/images/Group 27479 (1).png"})`,
    },
  };

  const location = useLocation();

  return (
    <div style={{ height: "100vh", background: "#FFFFFF" }}>
      <PageLayout>
        <DefaultNavbar
          routes={pageRoutes}
          action={{
            type: "external",
            route: "https://creative-tim.com/product/soft-ui-dashboard-pro-react",
            label: "buy now",
          }}
          transparent
          light
        />

        {/*
        {location?.pathname === '/login' ?
          <AppBar>
            <Box sx={!matchsm ?
              {
                height: '110px',
                background: 'rgba(255, 255, 255, 1)',
                p: 1,
                pr: 2,
                pl: 2,
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0px 4px 31px 0px rgba(0, 0, 0, 0.25)'
              } :
              {
                height: '124px',
                background: 'rgba(255, 255, 255, 1)',
                p: 1,
                pr: 2,
                pl: 2,
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0px 4px 31px 0px rgba(0, 0, 0, 0.25)'
              }}
            >
              <Box sx={{ width: '33%' }}>
                <img
                  src={imgB}
                  height={matchsm ? "84px" : "54px"}
                  style={matchsm ? { paddingLeft: '57px' } : { paddingLeft: '0px' }}
                  alt=""
                />
              </Box>

              <Box
                sx={{
                  width: '33%',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={imgC}
                  height={matchsm ? "70px" : "40px"}
                  alt=""
                />
              </Box>

              {matchsm ?
                <Box
                  sx={{
                    width: '33%',
                    display: 'flex',
                    justifyContent: 'flex-end'
                  }}
                >
                  <img
                    src={imgD}
                    height={"82px"}
                    style={{ paddingRight: '57px' }}
                    alt=""
                  />
                </Box> :
                null
              }
            </Box>
          </AppBar> :
          null
        }
        */}

        {location?.pathname === "/login" ? (
          <AppBar
            position="fixed"
            elevation={4}
            sx={{ background: "#FFFFFF", boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.20)" }}
          >
            <Toolbar
              sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1 }}
            >
              <img src={imageB} alt="" height={"80px"} />

              <img src={imageA} alt="" height={"87px"} />

              <img src={imageC} alt="" height={"57px"} />
            </Toolbar>
          </AppBar>
        ) : null}

        <Toolbar sx={{ background: "#FFFFFF", mt: 3 }} />

        <div className="InnerDiv">
          <Grid container sx={{ height: "100%" }}>
            {matchsm ? (
              <Grid item lg={8} md={8} sm={12} xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    p: 1,
                    pb: 0,
                    textAlign: "center",
                    borderRight: "1px solid #C4C4C4",
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={{
                      p: 2,
                      pb: 0,
                      color: "#3B5092",
                      fontFamily: "Markazi Text",
                      textShadow: "1px 1px 2px #C4C4C4",
                      fontSize: "79px",
                    }}
                  >
                    Saksham Rojgaar Sathi{" "}
                    <span style={{ fontSize: "30px", color: "#6C6C6C" }}>(SRS)</span>
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      p: 1,
                    }}
                  >
                    <div className="Line" />

                    <Typography variant="h5" sx={{ p: 1, color: "6C6C6C" }}>
                      Candidate Tracker Portal
                    </Typography>

                    <div className="Line1" />
                  </Box>

                  <Box
                    sx={{
                      m: "auto",
                      mt: 0,
                      mb: 1,
                      background: "#FFFFFF",
                      boxShadow: "0px 3px 6px 0px #C4C4C4",
                      borderRadius: "12px",
                      textAlign: "center",
                      width: "70%",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        p: 2,
                        pt: 1,
                        pb: 1,
                        fontStyle: "italic",
                        fontFamily: "Inter",
                        color: "#000000",
                      }}
                    >
                      <img src={imageE} />
                      &nbsp;
                      <span style={{ color: "#EA7500" }}>Empowering</span> Placement Service
                      Providers (PSPs)
                      <br />
                      with Real-time <span style={{ color: "#049C2F" }}>
                        Candidate Tracking
                      </span>{" "}
                      for Seamless
                      <br />
                      Job Placement Excellence &nbsp;
                      <img src={imageF} />
                    </Typography>
                  </Box>

                  <img src={imageD} height={"320px"} alt="" />
                </Box>
              </Grid>
            ) : null}

            <Grid item lg={4} md={4} sm={12} xs={12}>
              <Box sx={{ p: 2 }}>
                <Box sx={{ width: "100%", m: 2, mt: 3, display: "flex", justifyContent: "center" }}>
                  {/* <img src={imageG} alt="" height={"70px"} /> */}
                </Box>

                {userRole !== ADMIN ? (
                  <>
                    <SoftBox pt={1} px={1}>
                      <SoftBox mb={2}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 500,
                            fontSize: "24px",
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#000000",
                          }}
                        >
                          Login
                        </Typography>
                        <br />

                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#000000",
                          }}
                        >
                          Email Address
                        </Typography>

                        <ThemeProvider theme={customTheme(outerTheme)}>
                          <TextField
                            size="small"
                            fullWidth
                            type="email"
                            placeholder="Email"
                            value={loginEmail.email}
                            onChange={(e) => {
                              setLoginEmail({ ...loginEmail, email: e.target.value });
                            }}
                            onKeyPress={(e) => handleKeyPress(e)}
                          />
                        </ThemeProvider>
                      </SoftBox>
                      <SoftBox mb={4}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#000000",
                          }}
                        >
                          Password
                        </Typography>

                        <ThemeProvider theme={customTheme(outerTheme)}>
                          <TextField
                            size="small"
                            fullWidth
                            type={showPassword ? "text" : "password"}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end" sx={{ ml: "auto" }}>
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowPassword((show) => !show)}
                                    onMouseDown={handleChange}
                                    edge="end"
                                    sx={{ color: "#B3B6B7", ml: "auto" }}
                                  >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            placeholder="Password"
                            value={loginEmail.password}
                            onChange={(e) => {
                              setLoginEmail({ ...loginEmail, password: e.target.value });
                            }}
                            onKeyPress={(e) => handleKeyPress(e)}
                          />
                        </ThemeProvider>
                      </SoftBox>
                    </SoftBox>
                  </>
                ) : (
                  <>
                    <SoftBox pt={2} px={1}>
                      <SoftBox mb={2}>
                        <SoftTypography
                          variant="h10"
                          color="black"
                          fontWeight="350"
                          fontSize="15px"
                        >
                          Mobile Number
                        </SoftTypography>
                        <SoftBox display="flex">
                          <SoftInput
                            type="text"
                            placeholder="Mobile Number"
                            sx={{ mr: 1 }}
                            onChange={(e) => {
                              setOTP({ ...OTP, mobileno: e.target.value });
                            }}
                          />
                          {!otpbutton && (
                            <SoftBox
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#3B5092",
                                color: "#FFF",
                                minWidth: "94px",
                                fontSize: "14px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                // disabled: `${otpbutton}`,
                              }}
                              onClick={(e) => sendOtp()}
                            >
                              Get OTP
                            </SoftBox>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                    {otpinput && (
                      <SoftBox mb={4}>
                        <SoftTypography
                          variant="h10"
                          color="black"
                          fontWeight="350"
                          fontSize="15px"
                        >
                          OTP Expiry in {counter} Second
                        </SoftTypography>
                        <SoftInput
                          type="text"
                          placeholder="OTP"
                          onChange={(e) => {
                            setOTP({ ...OTP, otp: e.target.value });
                          }}
                        />
                        {/* <OtpInput                           
                          value={OTP}
                          onChange={setOTP}
                          separator={<span></span>}
                          numInputs={6}                         
                        /> */}
                      </SoftBox>
                    )}
                  </>
                )}

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Box sx={{ width: "200px", textAlign: "right" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "rgba(0, 115, 187, 1)",
                        paddingRight: "16px",
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "26px",
                        fontFamily: "Poppins",
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                      onClick={() => navigate("/forgotpassword1")}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Box>

                <SoftBox px={1}>
                  <SoftBox sx={matchsm ? { mt: 2, mb: 0 } : { mt: 4, mb: 1 }} align="center">
                    {/* <Link to="/agent/business"> */}
                    <>
                      {/* <SoftBox
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          width="93px"
                          height="39px"
                          borderRadius="5px"
                          sx={{ backgroundColor: "#FE5C00", color: "#fff", cursor: "pointer" }}
                        >
                          <SoftTypography
                            variant="button"
                            color="#fff"
                            onClick={handleLogin}
                            onKeyPress={handleKeyPress}
                          >
                            Login
                          </SoftTypography>
                        </SoftBox> */}
                      {/*
                            <button
                              className="login-btn"
                              onClick={handleLogin}
                            // onKeyPress={(e) => handleKeyPress(e)}
                            >
                              <span className="btn-txt">Login</span>
                            </button>
                            */}
                      <MuiButton
                        onClick={handleLogin}
                        sx={{
                          width: "100%",
                          height: "51px",
                          background: "rgba(255, 92, 0, 0.7)",
                          borderRadius: "10px",
                          textDecoration: "none",
                          textTransform: "none",
                          color: "#FFFFFF",
                          boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                          "&:hover": {
                            width: "100%",
                            height: "51px",
                            background: "rgba(255, 92, 0, 0.7)",
                            borderRadius: "10px",
                            textDecoration: "none",
                            textTransform: "none",
                            color: "#FFFFFF",
                            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                          },
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 600,
                            fontSize: "18px",
                            lineHeight: "26px",
                            fontFamily: "Poppins",
                            color: "#FFFFFF",
                          }}
                        >
                          {!isLoading ? "Login" : "Loading"}
                        </Typography>
                      </MuiButton>

                      {!matchsm ? (
                        <Box
                          sx={{
                            width: "100%",
                            height: "60px",
                            background: "rgba(255, 255, 255, 1)",
                            p: 1,
                            pb: 5,
                            pt: 7,
                            display: "flex",
                            flexWrap: "nowrap",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img src={imgD} height={"72px"} alt="" />
                        </Box>
                      ) : null}
                    </>
                    {/* </Link> */}
                    {/* <SoftBox mt={4} mb={1}>
                      {/* <Link to="/signup"> *
                      <SoftTypography color="black" fontWeight="350" fontSize="15px">
                        Yet to register?{" "}
                        <SoftTypography
                          component={Link}
                          to="/signup"
                          variant="button"
                          color="#FFFFFF"
                          fontWeight="bold"
                          textGradient
                        >
                          Sign Up
                        </SoftTypography>
                      </SoftTypography>
                      {/* </Link> *
                    </SoftBox> */}
                  </SoftBox>
                </SoftBox>
              </Box>
            </Grid>
          </Grid>
        </div>
      </PageLayout>
    </div>
  );
};

export default Login;
